import {useState} from "react";
import {simPrimariaFilterButtons} from "./SimPrimariaFilterHelper";
import Typography from "@material-ui/core/Typography";
import GrayHeaderCard from "../../../../../../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import {Grid, Input, InputLabel} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import {Search} from "@material-ui/icons";
import InlineRadioButtons
    from "../../../../../../../../../../ui/inputs/radio-buttons/inline-radio-buttons/InlineRadioButtons";
import PropTypes from "prop-types";

const SimPrimariaFilter = (props) => {
    const [searchText, setSearchText] = useState("")
    const [selectedRadioBtn, setSelectedRadioBtn] = useState(simPrimariaFilterButtons[0].value)

    const title = (
        <Typography variant={"subtitle2"}>
            Ricerca
        </Typography>
    )

    const handleInputChange = (e) => {
        setSearchText(e.target.value)
    }

    const handleEnterPressed = (e) => {
        if (e.which === 13)
            handleSearchIcon()
    }

    const handleSearchIcon = () => {
        if (searchText.length !== 0) {
            props.handleSearchIcon(selectedRadioBtn, searchText)
            setSearchText("");
        }
    }

    const handleRadioBtnChange = (e) => {
        setSelectedRadioBtn(e.target.value)
    }

    return (
        <>
            <GrayHeaderCard title={title}>
                <Grid container
                      justifyContent="space-between"
                      alignItems="center">
                    <Grid item container
                          alignItems="center"
                          xs={12} sm={8} md={9}>
                        <FormControl fullWidth>
                            <InputLabel>Cerca</InputLabel>
                            <Input labelid="filterSearchLabel"
                                   type="search"
                                   autoComplete="off"
                                   onChange={handleInputChange}
                                   value={searchText}
                                   onKeyPress={handleEnterPressed}
                                   endAdornment={
                                       <InputAdornment position="end">
                                           <IconButton onClick={handleSearchIcon}>
                                               <Search/>
                                           </IconButton>
                                       </InputAdornment>
                                   }/>
                        </FormControl>

                        <Typography variant="subtitle2"
                                    display="inline"
                                    style={{margin: "0.3em 1em"}}
                                    color="textSecondary">
                            Cerca per
                        </Typography>

                        <InlineRadioButtons value={selectedRadioBtn}
                                            radioButtons={simPrimariaFilterButtons}
                                            handleChange={handleRadioBtnChange}/>
                    </Grid>
                </Grid>

            </GrayHeaderCard>

        </>
    )
}

SimPrimariaFilter.propTypes = {
    handleSearchIcon: PropTypes.func.isRequired,
    handleSelectSearch: PropTypes.func.isRequired
}

export default SimPrimariaFilter;